import React from 'react'
import { NavigationHeadCollapsed } from '../index';
import './navigation.scss';

export const CollapsedNav = ({ activeNavHead, menuItems, onHeadClick }) => {
    const isSignOutLabel = (label) => { return label === "Sign Out" ? true : false };

    return (
        <div className='bsw-navigation--collapsed-list' role="list">
            {
                menuItems.map((item, index) => {
                    return ((item?.navHead?.icon || isSignOutLabel(item?.navHead?.label)) &&
                        <NavigationHeadCollapsed
                            active={activeNavHead === `${index}`}
                            className={item?.navHead?.className}
                            disabled={item?.disabled}
                            icon={isSignOutLabel(item?.navHead?.label) ? "logout" : item?.navHead?.icon}
                            index={`${index}`}
                            key={index}
                            label={item?.navHead?.label}
                            onClick={(e) => onHeadClick(e, index)}
                        />
                    )
                })
            }
        </div>
    )
}
